export const AtServiceDocumentTypes = {
    EvaluationDiscussionSigned: 16,
    Estipulation80: 18,
    DeliveredMinute: 19,
}